export const FETCH_SINGLE_DATA_FOR_REPORT_REQUEST_DK = 'FETCH_SINGLE_DATA_FOR_REPORT_REQUEST_DK';
export const FETCH_SINGLE_DATA_FOR_REPORT_SUCCESS_DK = 'FETCH_SINGLE_DATA_FOR_REPORT_SUCCESS_DK';
export const FETCH_SINGLE_DATA_FOR_REPORT_FAILURE_DK = 'FETCH_SINGLE_DATA_FOR_REPORT_FAILURE_DK';

export const FETCH_PROGRAM_WISE_DATA_FOR_REPORT_REQUEST_DK = 'FETCH_PROGRAM_WISE_DATA_FOR_REPORT_REQUEST_DK';
export const FETCH_PROGRAM_WISE_DATA_FOR_REPORT_SUCCESS_DK = 'FETCH_PROGRAM_WISE_DATA_FOR_REPORT_SUCCESS_DK';
export const FETCH_PROGRAM_WISE_DATA_FOR_REPORT_FAILURE_DK = 'FETCH_PROGRAM_WISE_DATA_FOR_REPORT_FAILURE_DK';

export const FETCH_CUTTING_WISE_DATA_FOR_REPORT_REQUEST_DK = 'FETCH_CUTTING_WISE_DATA_FOR_REPORT_REQUEST_DK';
export const FETCH_CUTTING_WISE_DATA_FOR_REPORT_SUCCESS_DK = 'FETCH_CUTTING_WISE_DATA_FOR_REPORT_SUCCESS_DK';
export const FETCH_CUTTING_WISE_DATA_FOR_REPORT_FAILURE_DK = 'FETCH_CUTTING_WISE_DATA_FOR_REPORT_FAILURE_DK';

export const SET_SUMMARY_GRID_NAME_PROGRAMWISE_REPORT_DK = 'SET_SUMMARY_GRID_NAME_PROGRAMWISE_REPORT_DK';

export const FETCH_PROGRAMWISE_DETAILED_REPORT_REQUEST_DK = 'FETCH_PROGRAMWISE_DETAILED_REPORT_REQUEST_DK';
export const FETCH_PROGRAMWISE_DETAILED_REPORT_SUCCESS_DK = 'FETCH_PROGRAMWISE_DETAILED_REPORT_SUCCESS_DK';
export const FETCH_PROGRAMWISE_DETAILED_REPORT_FAILURE_DK = 'FETCH_PROGRAMWISE_DETAILED_REPORT_FAILURE_DK';

export const FETCH_PROGRAMWISE_COMPLETED_REPORT_REQUEST_DK = 'FETCH_PROGRAMWISE_COMPLETED_REPORT_REQUEST_DK';
export const FETCH_PROGRAMWISE_COMPLETED_REPORT_SUCCESS_DK = 'FETCH_PROGRAMWISE_COMPLETED_REPORT_SUCCESS_DK';
export const FETCH_PROGRAMWISE_COMPLETED_REPORT_FAILURE_DK = 'FETCH_PROGRAMWISE_COMPLETED_REPORT_FAILURE_DK';

export const FETCH_PROGRAMWISE_CANCELLED_REPORT_REQUEST_DK = 'FETCH_PROGRAMWISE_CANCELLED_REPORT_REQUEST_DK';
export const FETCH_PROGRAMWISE_CANCELLED_REPORT_SUCCESS_DK = 'FETCH_PROGRAMWISE_CANCELLED_REPORT_SUCCESS_DK';
export const FETCH_PROGRAMWISE_CANCELLED_REPORT_FAILURE_DK = 'FETCH_PROGRAMWISE_CANCELLED_REPORT_FAILURE_DK';

export const SET_DETAIL_GRID_NAME_PROGRAMWISE_REPORT_DK = 'SET_DETAIL_GRID_NAME_PROGRAMWISE_REPORT_DK';
